module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "pictures_logo"
  }, [_c('span', {
    staticClass: "Small-Cap"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "Small-Cap"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "Small-Cap"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "Small-Cap"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "Small-Cap"
  }, [_vm._v("Also available")])]), _vm._v(" "), _c('p', {
    staticClass: "Dedication"
  }, [_c('span', {
    staticClass: "Small-Cap"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Centered"
  }, [_vm._v("More Random Acts o"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("f")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Kindness")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Centered"
  }, [_vm._v("Kids’ Random Acts o"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("f")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Kindness")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Centered"
  }, [_vm._v("The Practice o"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("f")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Kindness")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Centered"
  }, [_vm._v("The Community o"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("f")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Kindness")])]), _vm._v(" "), _c('p', {
    staticClass: "body_Body-Centered"
  }, [_vm._v("Practice Random Acts o"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("f")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Kindness")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e2f8ea1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RandomActsKindness.vue
// module id = 60
// module chunks = 0